"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clare = void 0;
exports.clare = {
    numberZero: 0,
    numberTen: 1000,
    amountZero: '0.00',
    amountNull: '--',
    amountTen: '10.00',
    amountTenNegative: '-10.00',
    usdSymbol: '$',
    usd: 'USD',
    saleNumber: 'TEST12345',
    saleId: 12345,
    statusSettled: 'settled',
    statusPaid: 'paid',
    orderType: 'Order',
    invoiceType: 'Invoice',
    storeId: 12345,
    storeName: 'Test store',
    storeContact: {
        full_name: 'Joe Smith',
        email_address: 'joe.smith@mailinator.com',
        phone: '555-555-5555',
    },
    acctType: 'visa',
    acctNum: '4242',
    acctTypeDisplay: 'Visa',
    txnId: 56789,
    tenderCard: 'C',
    cardLabel: 'Credit Card Payment',
    image: '',
};
